import React from "react";
import {Link} from "react-router-dom"
import {Card, CardActionArea, CardContent, CardMedia, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";

export default function Blog() {

    const articles = [
        {
            imgLink: '/pictures/blog/geelyGalaxyM9/photo_2025-09-20 23.41.20.jpeg',
            title: 'Galaxy M9: причины популярности без воды', date: '22 сентября 2025',
            description: "Технологии + комфорт + скорость под ваши сценарии. Баланс «хочу» и «надо»."
        },
        {
            imgLink: '/pictures/blog/geelyGalaxyM9/photo_2025-09-20 23.41.16.jpeg',
            title: 'Geely Galaxy M9 уже в Минске!', date: '22 сентября 2025',
            description: "Обсуждаемый всеми гибрид-флагман из Китая. Без долгих месяцев ожидания: авто уже на маршруте, на днях у нас."
        },
        {
            imgLink: '/pictures/blog/IMG_7213.JPG',
            title: '100% налоговый вычет для электромобилей', date: '3 декабря 2024',
            description: "Право получения 100% налогового вычета для бизнеса при покупке электромобилей в РБ. С 2024 года инвестиционный вычет доступен и для автомобилей в сфере каршеринга."
        },
        {
            imgLink: '/building_main.JPEG',
            title: 'Что на рынке авто', date: '2 ноября 2024',
            description: "Что сейчас продаётся на рынке автомобилей после летних 'бурных' продаж?"
        },
        {
            imgLink: '/pictures/blog/IMG_6082.JPG',
            title: 'Рекорд по продажам BYD Song Plus', date: '5 сентября 2024',
            description: '20 июля китайская автомобильная компания BYD Auto объявила о том, что общее количество проданных авто модели BYD Song Plus превзошло один миллион экземпляров.'
        },
        {
            imgLink: '/pictures/blog/IMG_6083.JPG',
            title: 'BYD на рынке электрокаров', date: '21 марта 2024',
            description: 'Если вы планируете приобрести электромобиль, то, скорее всего, уже столкнулись со сложностью '
                + 'выбора из-за представленного на рынке множества электромобилей из стран Европы, Китая, США и других.'
        },

        {
            imgLink: 'images/blog/IMG_2909.jpg',
            title: 'Нулевая растаможка для электрокаров', date: '25 ноября 2023',
            description: 'Продление освобождения от уплаты таможенной пошлины на электромобили в странах ЕАЭС до конца 2025 года'
        },

        {
            imgLink: 'images/post_1.jpg',
            title: 'Покупка авто в лизинг', date: '04 июня 2023',
            description: 'Что такое лизинг, возвратный лизинг. Оценка платежеспособности. Условия для физ. и юр. лиц.'
        }

    ];

    return (
        <div className="site-section">
            <div className="container">

                <Grid sx={{flexGrow: 1}} spacing={0} container justifyContent="space-evenly">

                    {articles.map((article, index) =>
                        <Article articleLink={'/blog/' + (articles.length - index)} imgLink={article.imgLink}
                                 title={article.title} description={article.description} date={article.date}/>
                    )}

                </Grid>


            </div>
        </div>

    );

    function Article({articleLink, imgLink, title, date, description}) {

        return (

            <Grid item>

                <Card sx={{maxWidth: 345}}>
                    <CardActionArea component={Link} to={articleLink}>
                        <CardMedia
                            component="img"
                            height="140"
                            image={imgLink}
                            alt={'Фото' + title}
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                                {title}
                            </Typography>
                            <Typography variant="body2" sx={{color: 'text.secondary'}}>
                                {description}
                            </Typography>

                            <Typography variant="body2" sx={{color: 'text.secondary', textAlign: 'right', mt:'5px', fontSize:'0.8rem'}}>
                                {date}
                            </Typography>

                        </CardContent>
                    </CardActionArea>
                </Card>
            </Grid>


            /* <div className="col-lg-4 col-md-6 mb-4">
            <div className="post-entry-1 h-100">

                <img src={imgLink} alt="Image" className="img-fluid" onClick={() => {
                    navigate(articleLink)
                }}
                     style={{cursor: "pointer"}}/>

                <div className="post-entry-1-contents">

                    <h2><a href={articleLink}>{title}</a></h2>
                    <span className="meta d-inline-block mb-3">{date}</span>
                    <p>{description}</p>
                </div>
            </div>
        </div>*/
        );
    }

}